import { io } from 'socket.io-client';

// Stessa origine: WebSocket su stesso host (porta unica). Per backend su altro host imposta REACT_APP_WS_URL
const WS_BASE =
  process.env.REACT_APP_WS_URL !== undefined
    ? String(process.env.REACT_APP_WS_URL).trim()
    : "";
const inferDevBackendBase = () => {
  if (typeof window === 'undefined') return '';
  const { protocol, hostname, port } = window.location;
  // CRA dev server (3000) + Nest backend (3001)
  if (port === '3000') return `${protocol}//${hostname}:3001`;
  return '';
};
const isDevFrontend = typeof window !== 'undefined' && window.location.port === '3000';
const socketBase = WS_BASE || inferDevBackendBase();
const socketUrl = socketBase ? `${socketBase}/machines-live` : "/machines-live";

export const machinesSocket = io(socketUrl, {
  path: '/socket.io',
  // In dev, some setups reject websocket upgrade: polling avoids noisy connection errors.
  transports: isDevFrontend ? ['polling'] : ['websocket', 'polling'],
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  autoConnect: false, // Connessione lazy: solo quando useMachinesLive è usato (Dashboard)
});
